export const normalize = (str: string) => str.toLowerCase().replace(/[-\s]/g, '');
